import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',

    'resource:data.enums.deployOutcome',
    'resource:data.enums.deployOutcome.entries.failed',
    'resource:data.enums.deployOutcome.entries.success',
    'resource:data.enums.pullRequestKind',
    'resource:data.enums.pullRequestKind.entries.approval',
    'resource:data.enums.pullRequestKind.entries.implementation',
    'resource:data.enums.pullRequestMergeState',
    'resource:data.enums.pullRequestMergeState.entries.closed',
    'resource:data.enums.pullRequestMergeState.entries.merged',
    'resource:data.enums.pullRequestMergeState.entries.open',
    'resource:data.enums.pullRequestReviewState',
    'resource:data.enums.pullRequestReviewState.entries.approved',
    'resource:data.enums.pullRequestReviewState.entries.changesRequested',
    'resource:data.enums.pullRequestReviewState.entries.inReview',
    'resource:data.enums.testOutcome',
    'resource:data.enums.testOutcome.entries.fail',
    'resource:data.enums.testOutcome.entries.pass',
    'resource:data.enums.engagementCharterComponentKind',
    'resource:data.enums.engagementCharterComponentKind.entries.bdNote',
    'resource:data.enums.engagementCharterComponentKind.entries.other',
    'resource:data.enums.engagementCharterComponentKind.entries.rfp',
    'resource:data.enums.engagementCharterComponentKind.entries.sow',
    'resource:data.enums.jiraStatus',
    'resource:data.enums.jiraStatus.entries.done',
    'resource:data.enums.jiraStatus.entries.inProgress',
    'resource:data.enums.jiraStatus.entries.inReview',
    'resource:data.enums.jiraStatus.entries.toDo',

    'resource:data.dimensions.epics',
    'resource:data.dimensions.epics.entities.epic',
    'resource:data.dimensions.epics.entities.epic.attributes.assignee',
    'resource:data.dimensions.epics.entities.epic.attributes.jiraStatus',
    'resource:data.dimensions.epics.entities.epic.attributes.observedAt',
    'resource:data.dimensions.epics.entities.epic.attributes.priority',
    'resource:data.dimensions.epics.entities.epic.attributes.project',

    'resource:data.dimensions.requirements',
    'resource:data.dimensions.requirements.entities.requirement',
    'resource:data.dimensions.requirements.entities.requirement.attributes.assignee',
    'resource:data.dimensions.requirements.entities.requirement.attributes.epic',
    'resource:data.dimensions.requirements.entities.requirement.attributes.jiraStatus',
    'resource:data.dimensions.requirements.entities.requirement.attributes.observedAt',
    'resource:data.dimensions.requirements.entities.requirement.attributes.priority',
    'resource:data.dimensions.requirements.entities.requirement.attributes.project',
    'resource:data.dimensions.requirements.entities.requirement.attributes.techReqFile',
    'resource:data.dimensions.requirements.entities.requirement.attributes.techReqPullRequest',

    'resource:data.dimensions.pullRequests',
    'resource:data.dimensions.pullRequests.entities.pullRequest',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.author',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.branch',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.commitSha',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.kind',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.mergeState',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.mergedAt',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.observedAt',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.project',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.reviewState',
    'resource:data.dimensions.pullRequests.entities.pullRequest.attributes.url',

    'resource:data.dimensions.specs',
    'resource:data.dimensions.specs.entities.spec',
    'resource:data.dimensions.specs.entities.spec.attributes.file',
    'resource:data.dimensions.specs.entities.spec.attributes.observedAt',
    'resource:data.dimensions.specs.entities.spec.attributes.pullRequest',

    'resource:data.dimensions.results',
    'resource:data.dimensions.results.entities.result',
    'resource:data.dimensions.results.entities.result.attributes.deployOutcome',
    'resource:data.dimensions.results.entities.result.attributes.deployedAt',
    'resource:data.dimensions.results.entities.result.attributes.pullRequest',
    'resource:data.dimensions.results.entities.result.attributes.testOutcome',
    'resource:data.dimensions.results.entities.result.attributes.testedAt',

    'resource:data.dimensions.engagementCharters',
    'resource:data.dimensions.engagementCharters.entities.engagementCharter',
    'resource:data.dimensions.engagementCharters.entities.engagementCharter.attributes.actor',
    'resource:data.dimensions.engagementCharters.entities.engagementCharter.attributes.documents',
    'resource:data.dimensions.engagementCharters.entities.engagementCharter.attributes.project',
    'resource:data.dimensions.engagementCharters.entities.engagementCharter.attributes.recordedAt',

    'resource:data.dimensions.engagementCharterComponents',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent.attributes.actor',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent.attributes.componentType',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent.attributes.documents',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent.attributes.project',
    'resource:data.dimensions.engagementCharterComponents.entities.engagementCharterComponent.attributes.recordedAt',

    'resource:data.dimensions.pullRequestRequirementLinks',
    'resource:data.dimensions.pullRequestRequirementLinks.entities.pullRequestRequirementLink',
    'resource:data.dimensions.pullRequestRequirementLinks.entities.pullRequestRequirementLink.attributes.observedAt',
    'resource:data.dimensions.pullRequestRequirementLinks.entities.pullRequestRequirementLink.attributes.pullRequest',
    'resource:data.dimensions.pullRequestRequirementLinks.entities.pullRequestRequirementLink.attributes.requirement',

    'resource:solutions.apps.attainSpecKit',
    'resource:solutions.apps.attainSpecKit.pages.build',
    'resource:solutions.apps.attainSpecKit.pages.deployment',
    'resource:solutions.apps.attainSpecKit.pages.design',
    'resource:solutions.apps.attainSpecKit.pages.maintenance',
    'resource:solutions.apps.attainSpecKit.pages.planning',
    'resource:solutions.apps.attainSpecKit.pages.requirementDetails',
    'resource:solutions.apps.attainSpecKit.pages.requirementsDashboard',
    'resource:solutions.apps.attainSpecKit.pages.testing',
    'resource:solutions.apps.attainSpecKit.pages.traceabilityMatrix',

    'resource:solutions.mosaic.pages.attainSpecKit.build',
    'resource:solutions.mosaic.pages.attainSpecKit.deployment',
    'resource:solutions.mosaic.pages.attainSpecKit.design',
    'resource:solutions.mosaic.pages.attainSpecKit.maintenance',
    'resource:solutions.mosaic.pages.attainSpecKit.planning',
    'resource:solutions.mosaic.pages.attainSpecKit.requirementDetails',
    'resource:solutions.mosaic.pages.attainSpecKit.requirementsDashboard',
    'resource:solutions.mosaic.pages.attainSpecKit.testing',
    'resource:solutions.mosaic.pages.attainSpecKit.traceabilityMatrix',

    'resource:solutions.mosaic.widgets.attainSpecKit.buildTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.deploymentPlaceholder',
    'resource:solutions.mosaic.widgets.attainSpecKit.designSpecsTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.engagementCharterComponentsTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.maintenancePlaceholder',
    'resource:solutions.mosaic.widgets.attainSpecKit.planningEpicsTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementDetails',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardAssigneeBar',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardStatusBar',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardStatusDonut',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardSummary',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.requirementsDashboardTypeBar',
    'resource:solutions.mosaic.widgets.attainSpecKit.testingTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixAwaitingApproval',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixCovered',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixOrphaned',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixPartial',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixTable',
    'resource:solutions.mosaic.widgets.attainSpecKit.traceabilityMatrixUnverified',
  ],
  description:
    'Spec Kit delivery-tracking data model (Jira epics and tasks, approval and implementation pull requests, specs, technical requirements, test and deploy results, and engagement charter records) plus the Attain Spec Kit Mosaic app for planning, designing, building, testing, deploying, and maintaining against it.',
  name: 'Attain Spec Kit',
} as const satisfies core.quiver.Package
